import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { browserHistory } from 'react-router';
import moment from 'moment';
import { processOrder } from '../../../redux/actions';

const PartsNetRequestReturnStep2 = props => {
	const [hasOverPolicyLimitItems, setHasOverPolicyLimitItems] = useState(false);
	const [returnOrderResponse, setReturnOrderResponse] = useState();
	const {
		order: { orderDetails: muleOrderDetails, requestReturnDetails },
		user
	} = useSelector(({ order, user }) => ({ order, user }));
	const dispatch = useDispatch();

	const orderDetails = requestReturnDetails && requestReturnDetails.responseObject;

	useEffect(() => {
		if (requestReturnDetails && requestReturnDetails.responseObject) {
			const relationShipTypes = user.relationShipPartyList.responseObject.filter(party => party.RELATIONSHIP_STATUS === 'A').map(item => item.RELATIONSHIP_TYPE);
			const invoice = user.allTcaList.responseObject.filter(item => relationShipTypes.includes(item.tcaRelationshipName));
			const defaultInvoice = user.allTcaList.responseObject.filter(item => item.tcaRelationshipName === 'Default');
			const invoiceAge = invoice.length > 0 ? invoice[0].invoiceAge : defaultInvoice[0].invoiceAge;

			const overLimit = requestReturnDetails.responseObject.items.some(
				item => item.selected && moment(item.invoiceDate).isBefore(moment().subtract(invoiceAge, 'days'), 'day')
			);

			setHasOverPolicyLimitItems(overLimit);
		} else {
			browserHistory.replace('/requestreturn');
		}
	}, [requestReturnDetails]);

	const poNumber = useMemo(() => {
		console.log('Create PO Number');
		if (orderDetails) {
			const previousReturnsOrderNumbers = [];
			orderDetails.items.forEach(item => {
				item.returnLines &&
					item.returnLines.length &&
					item.returnLines.forEach(returnLine => {
						if (!previousReturnsOrderNumbers.includes(returnLine.returnNumber)) {
							previousReturnsOrderNumbers.push(returnLine.returnNumber);
						}
					});
			});

			return `${orderDetails.poNumber}-RET${previousReturnsOrderNumbers.length + 1}`;
		} else {
			return '';
		}
	}, [orderDetails]);

	const handleBack = e => {
		e.preventDefault();

		browserHistory.goBack();
	};

	const getShipFromOrgId = item => {
		const foundMuleLineItem =
			muleOrderDetails &&
			muleOrderDetails.responseObject &&
			muleOrderDetails.responseObject.P_OUT_LINE_TBL &&
			muleOrderDetails.responseObject.P_OUT_LINE_TBL.P_OUT_LINE_TBL_ITEMS &&
			muleOrderDetails.responseObject.P_OUT_LINE_TBL.P_OUT_LINE_TBL_ITEMS.find(lineItem => lineItem.LINE_ID === item.lineId);

		let shipFromOrgId;
		if (foundMuleLineItem) {
			if (['202', '1431', '1432'].includes(foundMuleLineItem.SHIP_FROM_ORG_ID)) {
				// 202 - JEF, 1431 - RVR, 1432 - NAP
				shipFromOrgId = '202';
			} else {
				shipFromOrgId = foundMuleLineItem.SHIP_FROM_ORG_ID;
			}
		}

		return shipFromOrgId;
	};

	const handleSubmit = e => {
		e.preventDefault();

		if (hasOverPolicyLimitItems) {
			return;
		}

		const items = orderDetails.items.filter(item => item.selected);
		const orderCreationPayload = {
			P_OPERATION: 'CREATE',
			P_OPERATING_UNIT: 'GE US Appliances',
			RESPONSIBILITY: 'GEOM_SETUP _US_APL',
			RESP_APPLICATION: 'GEONT',
			SECURITY_GROUP: 'STANDARD',
			NLS_LANGUAGE: 'AMERICAN',
			P_HEADER_REC: {
				OPERATION: 'CREATE',
				ATTRIBUTE1: user.userDetails.sso,
				ATTRIBUTE2: user.userDetails.firstName+' '+user.userDetails.lastName,
				ATTRIBUTE8: orderDetails.deliveryPhone,
				ATTRIBUTE15: 'CUSTOMER RETURN',
				BOOKED_FLAG: 'Y',
				REQUEST_DATE: moment().format('YYYY-MM-DDT00:00:00'),
				CUST_PO_NUMBER: poNumber,
				// SHIPPING_INSTRUCTIONS: fields.shippingInstructions.trim(),
				BLANKET_NUMBER: orderDetails.agreementNumber,
				ORG_ID: 82,
				INVOICE_TO_ORG_ID: orderDetails.billingAddress && orderDetails.billingAddress.addressId,
				SHIP_FROM_ORG_ID: '202', // default to 202 for JEF
				SHIP_TO_ORG_ID: orderDetails.shippingAddress && orderDetails.shippingAddress.addressId
			},
			P_HEADER_VAL_REC: {
				CUSTOMER_NUMBER: orderDetails.accountNumber,
				ORDER_TYPE: 'Return Order',
				ORDER_SOURCE: 'PartsNet',
				// PRICE_LIST: selectedPriceSource.PRICE_LIST_NAME,
				SHIPPING_METHOD: orderDetails.shippingMethod,
				SHIPMENT_PRIORITY:
					muleOrderDetails.responseObject &&
					muleOrderDetails.responseObject.P_OUT_HEADER_VAL_REC &&
					muleOrderDetails.responseObject.P_OUT_HEADER_VAL_REC.SHIPMENT_PRIORITY
			},
			P_LINE_TBL: {
				P_LINE_TBL_ITEM: items.map((item, index) => ({
					OPERATION: 'CREATE',
					ORDERED_QUANTITY: +item.returnQuantity,
					LINE_NUMBER: (index + 1).toString(),
					ORG_ID: 82,
					SHIP_FROM_ORG_ID: getShipFromOrgId(item),
					RETURN_REASON_CODE: 'ARW',
					RETURN_CONTEXT: 'ORDER',
					RETURN_ATTRIBUTE1: orderDetails.headerId,
					RETURN_ATTRIBUTE2: item.lineId,
				}))
			},
			P_LINE_VAL_TBL: {
				P_LINE_VAL_TBL_ITEM: items.map(item => ({
					INVENTORY_ITEM: item.internalItem,
					SHIPPING_METHOD: orderDetails.shippingMethod,
					LINE_TYPE: 'Return Line'
				}))
			}
		};

		orderCreationPayload.UDA_PAYLOAD = {
			apiVersion: '1.0',
			objectName: 'OE_ORDER_HEADERS_ALL',
			rowTable: {
				rowTableTime: [
					{
						rowIdentifier: 9993,
						groupId: 1249,
						groupappId: 660,
						groupType: 'OE_HEADER_ATTRIBUTES_EXT',
						groupName: 'PARTS_MANUAL',
						dataLevel: 'ORDER_HEADER',
						transactionType: 'UPDATE'
					}
				]
			},
			dataTable: {
				dataTableItem: [
					{
						rowIdentifier: 9993,
						name: "Customer_Instructions",
						dispValue: requestReturnDetails.returnComments,
					},
					{
						rowIdentifier: 9993,
						name: "Encrypted_Messages",
						dispValue: "ARW",
					},
					{
						rowIdentifier: 9993,
						name: "EMail",
						dispValue: user.userDetails.email,
					},
				]
			},
			colValuePairs: {
				colValuePairsItem: [
					{
						name: 'HEADER_ID'
					}
				]
			},
			clsValuePairs: {
				clsValuePairsItem: [
					{
						name: 'ENTITY',
						value: 'ADMIN_DEFINED'
					}
				]
			}
		};

		console.log('Return Order Creation Payload: ', orderCreationPayload);

		dispatch(
			processOrder(orderCreationPayload, 'requestType=returnOrder&appName=PNET', true, returnOrderCreationResponse => {
				if (returnOrderCreationResponse.status && returnOrderCreationResponse.responseObject) {
					setReturnOrderResponse(returnOrderCreationResponse.responseObject);
				} else {
					browserHistory.push('/error');
				}
			})
		);
	};

	return (
		<div className="pNetRequestReturnStep2">
			{returnOrderResponse ? (
				<div className="push">
					<p className="textRight">
						<a className="withIcon withPrintIcon noUnderline bold uppercase" onClick={props.handlePrint} href="">
							Print Return Request Confirmation
						</a>
					</p>
					<h1 className="pageTitle">Return Request Confirmation</h1>
					<div>
						<p className="orange">
							<b>
								Thank you for Booking your return. This may take up to an hour. The Return Reference # below can be used to search for this return in View Returns &
								Credits.
							</b>
						</p>
					</div>
				</div>
			) : (
				<div className="push">
					<h1 className="pageTitle">Review Return Request</h1>
				</div>
			)}
				{hasOverPolicyLimitItems && (
								<div className="push" style={{ textAlign: 'left'}}>
									<p className="bold red" style={{ marginTop: '8px' }}>
										This request is older than allowed by the Return and Scrap Policy.
									</p>
								</div>
							)}
			{orderDetails && (
				<React.Fragment>
					{/* ── Mobile layout ── */}
					<div className="push d-block d-sm-none m-3">
						<p style={{ fontSize: '10px' }}>
							{returnOrderResponse && (
								<b>
									Return Reference #: {returnOrderResponse && returnOrderResponse.P_HEADER_REC && returnOrderResponse.P_HEADER_REC.ORIG_SYS_DOCUMENT_REF}
									<br />
								</b>
							)}
							<b style={{ fontSize: '10px' }}>Account #:</b> {orderDetails.accountNumber}
						</p>
						<div className="reviewReturnColumns">
							<div>
								<p>
									<b>Return Request Date:</b> {moment(requestReturnDetails.returnRequestDate).format('MM/DD/YYYY')}
									<br />
									<b>Return Reason:</b> {requestReturnDetails.returnReason}
									<br />
								</p>
							</div>
							<div>
								<p>
									<b>PO:</b> {poNumber}
									<br />
									<b>Comments:</b> {requestReturnDetails.returnComments}
									<br />
								</p>
							</div>
						</div>
					</div>

					{/* ── Desktop layout ── */}
					<div className="push d-none d-sm-block">
						<p>
							{returnOrderResponse && (
								<b>
									Return Reference #: {returnOrderResponse && returnOrderResponse.P_HEADER_REC && returnOrderResponse.P_HEADER_REC.ORIG_SYS_DOCUMENT_REF}
									<br />
								</b>
							)}
							<b>Account #:</b> {orderDetails.accountNumber}
						</p>
						<div className="columns reviewReturnColumns">
							<div className="column column3">
								<p>
									<b>Return Request Date:</b> {moment(requestReturnDetails.returnRequestDate).format('MM/DD/YYYY')}
									<br />
									<b>Return Reason:</b> {requestReturnDetails.returnReason}
									<br />
								</p>
							</div>
							<div className="column column4">
								<p>
									<b>PO:</b> {poNumber}
									<br />
									<b>Comments:</b> {requestReturnDetails.returnComments}
									<br />
								</p>
							</div>
						</div>
					</div>

					{/* ── Mobile items table ── */}
					<div className="push d-block d-sm-none m-3">
						<div className="captionAboveTable">
							<div className="columns ps-2">Original CSO (Order number): {orderDetails.originalOrderNumber}</div>
						</div>
						{orderDetails.items &&
							orderDetails.items.map((item, index) => {
								if (item.selected) {
									return (
										<div className="accordion accordion-borderless" id={`accordionRequestReturn3${index}`} key={index}>
											<div>
												<h2 className="accordion-header" id={`flush-requestReturn3${index}`}>
													<button
														className="accordion-button mobileAccButton"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target={`#flush-collapse3RR${index}`}
														aria-expanded="true"
														aria-controls={`flush-collapse3RR${index}`}
													>
														{item.internalItem}
													</button>
												</h2>
												<div
													id={`flush-collapse3RR${index}`}
													className={`accordion-collapse collapse show`}
													aria-labelledby={`flush-requestReturn3${index}`}
												>
													<table className="orderTable">
														<tbody>
															<tr className="border-bottom">
																<td className="p-3 fw-bold">RETURN TYPE</td>
																<td className="">{props.formatMoney(parseFloat(item.price).toFixed(2), 0, '.', ',', false, '$')}</td>
															</tr>
															<tr className="border-bottom">
																<td className="p-3 fw-bold">QUANTITY TO RETURN</td>
																<td className="quantityToReturn">
																	<b>{item.returnQuantity}</b>
																</td>
															</tr>
															<tr className="border-bottom">
																<td className="p-3 fw-bold">INVOICE #</td>
																<td className="originalInvoiceNumber">
																	<b>{item.invoiceNumber}</b>
																</td>
															</tr>
															<tr className="border-bottom">
																<td className="p-3 fw-bold">INVOICE DATE</td>
																<td className="">
																	<b>{item.invoiceDate ? moment(item.invoiceDate).format('MM/DD/YYYY') : ''}</b>
																</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
									);
								}
								return null;
							})}
					</div>

					{/* ── Desktop items table ── */}
					<div className="push d-none d-sm-block">
						<h2>Original CSO (Order number): {orderDetails.originalOrderNumber}</h2>
						<table id="reviewReturnsTable" className="reviewReturnTable dataTableType2 noRowBorders" style={{ borderBottom: '1px solid #555' }}>
							<thead>
								<tr className="viperDarkHeader">
									<th className="item">Item</th>
									<th className="price text-right">Price</th>
									<th className="quantityToReturn text-right">Quantity to Return</th>
									<th className="invoiceNumber originalInvoiceNumber">Invoice #</th>
									<th className="invoiceDate">Invoice Date</th>
								</tr>
							</thead>
							<tbody>
								{orderDetails.items &&
									orderDetails.items.map((item, index) => {
										if (item.selected) {
											return (
												<tr key={index}>
													<td className="item">
														<b>{item.internalItem}</b>
													</td>
													<td className="price text-right">
														<b>{props.formatMoney(parseFloat(item.price).toFixed(2), 0, '.', ',', false, '$')}</b>
													</td>
													<td className="quantityToReturn text-right">
														<b>{item.returnQuantity}</b>
													</td>
													<td className="invoiceNumber">
														<b>{item.invoiceNumber}</b>
													</td>
													<td className="invoiceDate">
														<b>{item.invoiceDate ? moment(item.invoiceDate).format('MM/DD/YYYY') : ''}</b>
													</td>
												</tr>
											);
										}
										return null;
									})}
							</tbody>
						</table>
					</div>

					{/* ── Over-policy warning + action buttons ── */}
					{!returnOrderResponse && (
						<React.Fragment>
						
							<p className="flex justify-between py-3">
								<a className="blueButton px-4 py-2" href="" onClick={handleBack} style={{ fontSize: '1rem' }}>
									Back
								</a>
								<a
									className="blueButton p-2"
									href=""
									onClick={hasOverPolicyLimitItems ? e => e.preventDefault() : handleSubmit}
									style={{
										fontSize: '1rem',
										...(hasOverPolicyLimitItems ? { opacity: 0.5, cursor: 'not-allowed', pointerEvents: 'none' } : {})
									}}
								>
									Submit Return Request
								</a>
							</p>
						</React.Fragment>
					)}
				</React.Fragment>
			)}
		</div>
	);
};

export default PartsNetRequestReturnStep2;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/partsNetRequestReturnStep2.jsx